// extracted by mini-css-extract-plugin
export default {"container":"container__l7H1Z","main":"main__c7dZk"};